import React from 'react';
import PropTypes from 'prop-types';
import { Label } from '@acpaas-ui/react-components';

const OfferingsListItem = ({ title, shortDescription, themes, onSelect }) => {
  return (
    <div className="spo-m-offerings-list-item" role="link" onClick={onSelect}>
      <div className="spo-m-offerings-list-item__title">
        <h6 className="u-margin-bottom-xs u-text-bold u-text-primary">{title}</h6>
        {themes?.map((t, i) => (
          <Label key={`${t}_${i}`} className="u-margin-bottom-xs u-margin-right-sm" type="primary">
            {t}
          </Label>
        ))}
      </div>
      <div>{shortDescription}</div>
    </div>
  );
};

OfferingsListItem.propTypes = {
  id: PropTypes.string,
  title: PropTypes.string,
  shortDescription: PropTypes.string,
  themes: PropTypes.arrayOf(PropTypes.string),
  onSelect: PropTypes.func
};
export default OfferingsListItem;
